export const userTypes = {
  INTERNAL: 'internal',
  CUSTOMER: 'customer',
  PARTNER_USER: 'partner_user',
  PARTNER_ADMIN: 'partner_admin'
};



// WEBPACK FOOTER //
// ./src/constants/userTypes.js